import { render, staticRenderFns } from "./ReportedUsers.vue?vue&type=template&id=08a0841d&scoped=true&"
import script from "./ReportedUsers.vue?vue&type=script&lang=js&"
export * from "./ReportedUsers.vue?vue&type=script&lang=js&"
import style0 from "./ReportedUsers.vue?vue&type=style&index=0&id=08a0841d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a0841d",
  null
  
)

export default component.exports